"use client";

import { useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { setBugsnagUser } from "@/lib/bugsnag";

export default function BugsnagUserSync(): null {
  const { user } = useAuth();
  useEffect(() => {
    setBugsnagUser(user);
  }, [user]);
  return null;
}
